import React from 'react'

import { AgentVerified } from 'components/lib/DesignSystem/Icons'

import { VerifiedIconBadge } from '../styles'

const ICON_SIZE_BY_VARIANT = {
  row: '12px',
  banner: '16px',
}

const AgentVerifiedMark = ({ variant = 'row', className, ...iconProps }) => (
  <VerifiedIconBadge $variant={variant} className={className}>
    <AgentVerified
      noDefaultFill
      width={ICON_SIZE_BY_VARIANT[variant]}
      height={ICON_SIZE_BY_VARIANT[variant]}
      fill="var(--color-text)"
      {...iconProps}
    />
  </VerifiedIconBadge>
)

export default AgentVerifiedMark
